import { Component, OnInit, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AdditionalDetails } from 'src/app/locums/models/additional-details.interface';
import { LocumsJobService } from 'src/app/locums/services/locums-job.service';

@UntilDestroy()
@Component({
  selector: 'nova-locums-recruiter-will-license',
  templateUrl: './locums-recruiter-will-license.component.html',
  styleUrls: ['./locums-recruiter-will-license.component.scss']
})
export class LocumsRecruiterWillLicenseComponent implements OnInit {
  @Input() jobId: number;

  locumsJobAdditionalDetails: AdditionalDetails;

  constructor(private readonly locumsJobService: LocumsJobService) { }

  ngOnInit(): void {
    this.getAdditionalDetails(this.jobId);
  }

  getAdditionalDetails(jobId: number): void {
    this.locumsJobService
      .getAdditionalDetails(jobId)
      .pipe(untilDestroyed(this))
      .subscribe((additionalDetails: AdditionalDetails) => {
        this.locumsJobAdditionalDetails = additionalDetails;
      });
  }
}
